import * as v from '@badrap/valita'
import { createStorageCategory } from 'src/storage'

export const storageKey = 'ORG_INFO'

const createStorage = createStorageCategory('session', storageKey)

export const savedChanges = createStorage('changes', v.array(v.string()))

export const savedLogoutOnLogin = createStorage('logout_on_login', v.boolean())
export const savedSplashIos1 = createStorage('splash_ios_1', v.string())
export const savedSplashIos2 = createStorage('splash_ios_2', v.string())
export const savedSplashAndroid1 = createStorage('splash_android_1', v.string())
export const savedSplashAndroid2 = createStorage('splash_android_2', v.string())
export const savedKvps = createStorage('kvps', v.array(v.string()))
export const savedChatRegion = createStorage('chat_region', v.string())
export const savedCountryCode = createStorage('country_code', v.string())
// prettier-ignore
export const savedAutoReadyLogin = createStorage('auto_ready_login', v.boolean())
// prettier-ignore
export const savedActivityTimeout = createStorage('activity_timeout', v.number())
export const savedDebugTimeout = createStorage('debug_timeout', v.number())
// prettier-ignore
export const savedDisabledAutoMarkdone = createStorage('disabled_auto_markdone', v.boolean())
export const savedIAMUserGroup = createStorage('iam_usergroup', v.string())
export const savedIAMAccessKey = createStorage('iam_access_key', v.string())
// prettier-ignore
export const savedIAMAccessSecret = createStorage('iam_access_secret',v.string())
export const savedIAMPolicyArn = createStorage('iam_policy_arn', v.string())
// prettier-ignore
export const savedSfButtonEnabled = createStorage('sf_button_enabled', v.boolean())
export const savedSfButtonKey = createStorage('sf_button_key', v.string())
export const savedSfCallLogging = createStorage('sf_call_logging', v.boolean())
export const savedSfLoginUrl = createStorage('sf_login_url', v.string())
export const savedSfPrincipalArn = createStorage('sf_principal_arn', v.string())
export const savedSfRoleArn = createStorage('sf_role_arn', v.string())
export const savedSfClientId = createStorage('sf_client_id', v.string())
export const savedSfClientSecret = createStorage('sf_client_secret', v.string())
export const savedSfAuthUrl = createStorage('sf_auth_url', v.string())
export const savedSfEndpoint = createStorage('sf_endpoint', v.string())
export const savedSfUsername = createStorage('sf_username', v.string())
export const savedSfPassword = createStorage('sf_password', v.string())
// prettier-ignore
export const savedCrmButtonEnabled = createStorage('crm_button_enabled', v.boolean())
export const savedCrmButtonKey = createStorage('crm_button_key', v.string())
// prettier-ignore
export const savedConnectArn = createStorage('organization_connect_arn',v.string())
export const savedSamlUrl = createStorage('aws_connect_saml_url', v.string())

export type SavedBoolean = typeof savedLogoutOnLogin
export type SavedString = typeof savedSplashIos1
export type SavedNumber = typeof savedActivityTimeout
export type SavedCountryCode = typeof savedCountryCode
